import { render } from "./Methodology.vue?vue&type=template&id=36c1864c&scoped=true&ts=true"
import script from "./Methodology.vue?vue&type=script&lang=ts"
export * from "./Methodology.vue?vue&type=script&lang=ts"

import "./Methodology.vue?vue&type=style&index=0&id=36c1864c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c1864c"]])

export default __exports__